import config from 'config/config';
import { BusinessChoiceType } from 'features/utils/types';
import { useSelector } from 'react-redux';
import { BusinessChoiceSelector } from 'store/selectors';
import { notifySentry } from 'utils/error/notifySentry';

export function getDefaultCounter(businessChoice: BusinessChoiceType) {
  // TODO: to avoid issue here we need to ensure the config option used as default is also available in API Items
  return businessChoice === 'b2b'
    ? config.options.counter[2] // TRI_N for b2b
    : config.options.counter[0]; // MONO for b2c
}

export default function useCounterConfig() {
  const businessChoice = useSelector(BusinessChoiceSelector);
  const defaultCounter = getDefaultCounter(businessChoice);

  if (!businessChoice) {
    // TODO: Sentry (this should not happen as businessChoice page should always be before this is used)
    notifySentry(new Error('useCounterConfig: businessChoice is not defined'));
  }

  return { defaultCounter };
}
